<template>
  <el-col class="mb10" :xs="24" :sm="w100 ? 24 : 12" :md="w100 ? 24 : w50 ? 12 : 8">
    <div class="w100 flex-box al-c">
      <div class="tx-r" :style="{ 'width': this.width ? this.width + 'em' : 'auto' }">{{ typeData.label }}：</div>
      <div class="flex-1">
        <el-date-picker style="width: 100%;" v-model="value" type="daterange" unlink-panels value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">></el-date-picker>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: "BEDateComp",
  props: ["type-data", "w50", "w100", "width"],
  components: {},
  data() {
    return {
      value: null
    };
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: auto;
}
</style>
